var map = {
	"./Accordion_comp.png": 534,
	"./Audio_comp.png": 535,
	"./Carousel_comp.png": 536,
	"./CeAssets.png": 172,
	"./Congratulate.png": 309,
	"./Course_Image_Flip.svg": 1073,
	"./Draggables_comp.png": 537,
	"./Flip_card.svg": 1074,
	"./Group_sidebar_logo.png": 313,
	"./ImageSelect_comp.png": 538,
	"./Image_text.png": 539,
	"./Imagemapping_comp.png": 540,
	"./Marketing_Data.png": 541,
	"./Ordered_comp.png": 542,
	"./Photographs.png": 543,
	"./Price_Quotation.png": 544,
	"./Quizzes_comp_.png": 545,
	"./Quotes.svg": 1075,
	"./Scenario.svg": 1076,
	"./Schematics.png": 546,
	"./Software_Source_Code.png": 547,
	"./Tab_comp.png": 548,
	"./Test_Data.png": 549,
	"./Textbooks.png": 550,
	"./Topicdesc_comp.png": 551,
	"./Unordered_comp.png": 552,
	"./Video_comp.png": 553,
	"./alert_warning.png": 554,
	"./arrow_next.png": 402,
	"./arrow_prev.png": 403,
	"./assesment_wizard.png": 555,
	"./back-ten_1.png": 404,
	"./bg.jpg": 1077,
	"./bg_1.JPG": 1078,
	"./bg_1_.JPG": 1079,
	"./bg_2.jpeg": 1080,
	"./car_image.png": 556,
	"./cc_text.svg": 1081,
	"./ce_author.png": 235,
	"./ce_logo_skill_comp.png": 121,
	"./ce_notes.png": 557,
	"./ce_notes_bribery.png": 558,
	"./certificate.png": 559,
	"./certificate_print.png": 405,
	"./content_cancel.png": 314,
	"./content_plus.png": 315,
	"./cuepoints_notes.png": 401,
	"./cuepoints_window.png": 400,
	"./default_icon.png": 560,
	"./drag_and_match.png": 561,
	"./expand_tree.png": 406,
	"./flags/ar_BH.svg": 1082,
	"./flags/ar_MA.svg": 1083,
	"./flags/cs_CZ.svg": 1084,
	"./flags/da_DK.svg": 1085,
	"./flags/de_DE.svg": 1086,
	"./flags/en_US.svg": 1087,
	"./flags/es_ES.svg": 1088,
	"./flags/es_LA.svg": 1089,
	"./flags/fi_FI.svg": 1090,
	"./flags/fr_CA.svg": 1091,
	"./flags/fr_FR.svg": 1092,
	"./flags/he_HE.svg": 1093,
	"./flags/it_IT.svg": 1094,
	"./flags/ja_JP.svg": 1095,
	"./flags/kn_IN.svg": 1096,
	"./flags/ko_KR.svg": 1097,
	"./flags/ms_MY.svg": 1098,
	"./flags/nl_NL.svg": 1099,
	"./flags/pl_PL.svg": 1100,
	"./flags/pt_BR.svg": 1101,
	"./flags/ru_RU.svg": 1102,
	"./flags/sv_SE.svg": 1103,
	"./flags/th_TH.svg": 1104,
	"./flags/tr_TR.svg": 1105,
	"./flags/vi_VN.svg": 1106,
	"./flags/zh_CN.svg": 1107,
	"./flags/zh_TW.svg": 1108,
	"./forward-ten_1.png": 407,
	"./full_screen.svg": 1109,
	"./laptop_icon.png": 562,
	"./legend_help.svg": 1110,
	"./logo.svg": 1111,
	"./man_standing.png": 563,
	"./mute.svg": 1112,
	"./noun_pagination_99092.png": 564,
	"./pause.svg": 1113,
	"./pdf.png": 565,
	"./phone_icon.png": 566,
	"./play.svg": 1114,
	"./powered_by.png": 316,
	"./ppt.png": 567,
	"./profile_icon.png": 211,
	"./profile_logo.jpg": 1115,
	"./reorder-icon.png": 568,
	"./replay.svg": 1116,
	"./schar_certificate.png": 569,
	"./search.png": 570,
	"./suppliment_yellow.svg": 1117,
	"./tablet_icon.png": 571,
	"./teck_uk.png": 245,
	"./testimonal_text.png": 572,
	"./topic_header.png": 573,
	"./volume.svg": 1118,
	"./widget_yellow.svg": 1119,
	"./window_tab.png": 574,
	"./word.png": 575,
	"./xlsx.png": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;